import { GlobalListTable } from '@global-dax-ad-platform/dax-components';
import { ListTableProvider, useListTable } from '@global-engineering-shared/gweb-material-lab';
import React from 'react';

import useDataManagementTableColumns from 'features/DataManagement/components/DataManagementTable/components/DataManagementTableColumns/DataManagementTableColumns';
import useStyles from 'features/DataManagement/components/DataManagementTable/DataManagementTable.styles';
import { CurrentUploadedFile } from 'features/DataManagement/data/CurrentUploadedFile';

type CurrentUploadedFileWithStatus = CurrentUploadedFile & {
  uploadInProgress: boolean;
};

type DataManagementTableProps = {
  data: CurrentUploadedFileWithStatus[];
};

const DataManagementTable: React.FC<DataManagementTableProps> = ({ data }) => {
  const columns = useDataManagementTableColumns();
  const classes = useStyles();

  const instance = useListTable<CurrentUploadedFileWithStatus>({
    data,
    columns,
    rowCount: data.length,
    getRowId: (row) => row.fileType,
  });

  return (
    <ListTableProvider instance={instance}>
      <div className={classes.tableWrapper}>
        <GlobalListTable<CurrentUploadedFileWithStatus> data-tc="data-management-table" />
      </div>
    </ListTableProvider>
  );
};

export default DataManagementTable;
